import { copy } from '@/content/copy';
import { cn } from '@/lib/cn';

type Size = 'nav' | 'footer';

/** Transparent PNG exported from the supplied PSD, cropped to the artwork. */
const LOGO_SRC = '/images/xcoinglobal-logo.png';
const LOGO_WIDTH = 1578;
const LOGO_HEIGHT = 329;

const sizeClass: Record<Size, string> = {
  nav: 'h-8 md:h-10',
  footer: 'h-8',
};

interface LogoProps {
  size?: Size;
  className?: string;
}

/** XCoinGlobal image logo. Height alone sets the rendered size; width follows the aspect. */
export function Logo({ size = 'nav', className }: LogoProps) {
  return (
    <img
      src={LOGO_SRC}
      alt={copy.brand.name}
      width={LOGO_WIDTH}
      height={LOGO_HEIGHT}
      draggable={false}
      decoding="async"
      className={cn('block w-auto max-w-full select-none', sizeClass[size], className)}
    />
  );
}
